import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
// import { Dialog } from "./components/index.js";
import { Modal } from "react-responsive-modal";
import "./TVLAccidentModal.scss";

export default function TVLAccidentQuestion(props) {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(true);
  // const [isOpen, setIsOpen] = useState(true);

  const onNoClicked = () => {
    setIsOpen(false);
    if (typeof props.onNo === "function") {
      props.onNo();
    }
  };

  const onYesClicked = () => {
    setIsOpen(false);
    if (typeof props.onYes === "function") {
      props.onYes();
    }
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal
        classNames={{ modal: "TVLAccidentModal" }}
        open={isOpen}
        onClose={onClose}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        showCloseIcon={false}
      >
        <h2 style={{ marginTop: 30 }}>
          {t("description.TVLAccidentQuestionHeader")}
        </h2>
        <img className="img" src={props.logo} alt="trx now logo" />
        <div class="message">{t("description.TVLAccidentQuestion")}</div>
        <div className="footerContainer">
          <div type="hidden" onClick={onNoClicked} className="footer">
            <span>{t("description.ConfirmServicesFlatNo")}</span>
          </div>
          <div type="hidden" onClick={onYesClicked} className="footer">
            <span>{t("description.ConfirmServicesFlatYes")}</span>
          </div>
        </div>
      </Modal>
    </>
  );
}
